import React, { Dispatch, SetStateAction, useEffect, useMemo, useState } from "react";

export interface TextualConfigurationContextValue {
	active: boolean;
	setActive: Dispatch<SetStateAction<boolean>>;
}

const SHOW_TEXTUAL_CONFIGURATION_KEY = "CFG_SHOW_TEXTUAL_CONFIGURATION";

export const TextualConfigurationContext = React.createContext<
	TextualConfigurationContextValue | undefined
>(undefined);

export const TextualConfigurationWrapper: React.FC = (props) => {
	const [active, setActive] = useState<boolean>(
		!!localStorage.getItem(SHOW_TEXTUAL_CONFIGURATION_KEY) || false
	);

	useEffect(() => {
		localStorage.setItem(SHOW_TEXTUAL_CONFIGURATION_KEY, active ? "1" : "");
	}, [active]);

	const textualConfigurationContextValue = useMemo<TextualConfigurationContextValue>(
		() => ({
			active,
			setActive,
		}),
		[active]
	);

	return (
		<TextualConfigurationContext.Provider value={textualConfigurationContextValue}>
			{props.children}
		</TextualConfigurationContext.Provider>
	);
};
